import { render, staticRenderFns } from "./saleDia.vue?vue&type=template&id=6587b4c3&scoped=true&"
import script from "./saleDia.vue?vue&type=script&lang=js&"
export * from "./saleDia.vue?vue&type=script&lang=js&"
import style0 from "./saleDia.vue?vue&type=style&index=0&id=6587b4c3&lang=scss&scoped=true&"
import style1 from "./saleDia.vue?vue&type=style&index=1&id=6587b4c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587b4c3",
  null
  
)

export default component.exports